import instance from '../../URL/index';
const axios = instance.axios;
const _API = instance._API;

export default {
    services: {
        getDestinationsOptions: (token = "") => {
            return axios(token).get(`${_API}/destinations-options`);
        }
    }
}